import { Component } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OneWebComponentsAngularModule } from '@one/angular';
import { RecipientsSearchService } from './recipients-search.service';

@Component({
  selector: 'dl-recipients-search',
  standalone: true,
  imports:[OneWebComponentsAngularModule,ReactiveFormsModule,FormsModule],
  templateUrl: './recipients-search.component.html',
  styleUrl: './recipients-search.component.scss'
})
export class RecipientsSearchComponent {

  public searchbox = new FormControl();
  public constructor(private recipientsSearchService: RecipientsSearchService) {}
 

 public ngOnInit(): void {
  this.searchbox.valueChanges.subscribe(value => {
    const trimmed = (value || '').trim().toLowerCase();
    this.applyFilter(trimmed);
  });
}

  
  public applyFilter(filterValue: string): void {
    this.recipientsSearchService.getSearchedData(filterValue.trim().toLocaleLowerCase());
  }
  
}
